import { annualStatementSchema } from "@fideus-core/annual-statement";
import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { BalanceSheetPage } from "../../../../../companies/balanceSheet/BalanceSheetPage";

const pathSchema = z.object({
  companyId: annualStatementSchema.shape.companyId,
  year: z.preprocess(
    (val) => z.coerce.number().parse(val),
    annualStatementSchema.shape.year
  ),
});

export const Route = createFileRoute("/firmen/$companyId/jahre/$year/bilanz")({
  component: BalanceSheetRoute,
  params: zodValidator(pathSchema),
});

function BalanceSheetRoute() {
  const { companyId, year } = Route.useParams();
  return (
    <Container>
      <BalanceSheetPage companyId={companyId} year={year} />
    </Container>
  );
}
